// extracted by mini-css-extract-plugin
module.exports = {"active":"Navbar-module--active--2TWpl"};